export default __webpack_public_path__ + "static/media/architecture-img-12.427e139e.jpg";